import { User } from './entities/user.entity';

export function lastAccessedAccount<T extends Pick<User, 'lastLogin'>>(accounts: T[]): T | undefined {
  return accounts.reduce<T | undefined>((latest, account) => {
    const at = Date.parse(account.lastLogin ?? '');
    if (Number.isNaN(at)) return latest;
    return !latest || at > Date.parse(latest.lastLogin as string) ? account : latest;
  }, undefined);
}

export function lastAccessedFirst<T extends Pick<User, 'lastLogin'>>(accounts: T[]): T[] {
  const latest = lastAccessedAccount(accounts);
  return latest ? [latest, ...accounts.filter(account => account !== latest)] : accounts;
}
